import React, { useContext } from "react";
import styles from "./index.module.less";
import RightContent from "@/components/ThirdApp/components/RightContent";
import { Tabs } from "antd";
import IconFont from "@/components/icon";
import "./index.less";
import { scrollToTop } from "../../utils";
import { RECENT_GRROUP_ID } from "@/components/ThirdApp";

const { TabPane } = Tabs;

function ThirdApplications ({
  groups,
  onManageFavoriteApp,
  isApplications
}: {
  groups: any;
  onManageFavoriteApp: Function;
  isApplications?: boolean;
}) {
  //   console.log("this is groups", groups);
  function tabChange (id: any) {
    const jumpName = document.getElementById(id);
    const contentDom = document.getElementById("content_scroll_id");
    const contentScrollDom: any = contentDom?.querySelector(".scroll-view-content");
    const offsetTop = jumpName?.offsetTop || 0;
    scrollToTop(contentScrollDom, offsetTop, 400);
  }
  function openSetting () {
    onManageFavoriteApp?.();
  }
  return (
    <div className={`thirdApplications_container ${styles["container"]}`}>
      <div className={styles["title"]}>
        <div className={styles["content"]}>
          <span className={styles["icon"]}>
            <IconFont
              type="iconapp_tabbar_application"
              style={{ color: "#fff", fontSize: "10px" }}
            />
          </span>
          全部应用
        </div>
        {isApplications && (
          <div className={styles["label"]} onClick={openSetting}>
            <IconFont type="iconic_app_set" style={{ fontSize: "16px", color: "#62656D" }} />
            <span className={styles["text"]}>管理应用</span>
          </div>
        )}
      </div>
      <div className={styles["content"]}>
        <Tabs defaultActiveKey="1" tabPosition="top" style={{ height: 220 }} onChange={tabChange}>
          {groups.map((item: any, i: number) => {
            if (item.groupId === RECENT_GRROUP_ID) {
              return "";
            }
            const name = item.name;
            const id = item.groupId;
            return <TabPane tab={name} key={name} />;
          })}
        </Tabs>
        <RightContent groups={groups} loading={false} moreHidden={false} />
      </div>
    </div>
  );
}

export default React.memo(ThirdApplications);
